module.exports = __webpack_public_path__ + "img/networking.ddd3805d.png";